<template>
<LSection>
  <div class="fetch__error"><span>404, Cosy Apartments</span></div>
</LSection>
</template>